import "./style.css";
import { loadSchedule } from "./data/schedule";
import { mountFilters } from "./ui/Filters";
import { mountScheduleList } from "./ui/ScheduleList";
import { mountPreview } from "./ui/Preview";

async function bootstrap() {
  const allSets = await loadSchedule();
  mountFilters(document.querySelector<HTMLElement>("#col-filters")!);
  mountScheduleList(document.querySelector<HTMLElement>("#col-schedule")!, allSets);
  mountPreview(document.querySelector<HTMLElement>("#col-preview")!, allSets);

  // Hide loading screen
  const loader = document.querySelector<HTMLElement>("#boot-loader");
  if (loader) loader.style.display = "none";
}

bootstrap().catch(err => {
  console.error("Boot failed:", err);
  document.body.innerHTML = `<div style="color:#fff; padding:40px; font-family:sans-serif;">
    <h1>Failed to load schedule</h1>
    <pre>${(err as Error).stack ?? err}</pre>
  </div>`;
});
